import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import {
  COURSE_PAUSE_REQUEST_STATUSES,
  CoursePauseRequestPagination,
  currentPageSelector,
  useFilteredCoursePauseRequests,
} from 'features/courseResume';
import ElementSpacePlaceholder from 'components/ElementSpacePlaceholder';
import ErrorLayout from 'components/ErrorLayout';
import GlobalLoader from 'components/GlobalLoader';
import Loader from 'components/Loader';
import styles from './ToBeResumedTable.module.scss';
import Table from 'components/Table';
import TableBody from 'components/TableBody';
import ToBeResumedTableHeader from '../ToBeResumedTableHeader';
import ToBeResumedTableRow from '../ToBeResumedTableRow';

function ToBeResumedTable() {
  const { requestType } = useParams();
  const currentPage = useSelector(currentPageSelector);
  const { data, isLoading, error, refetch, isFetching } =
    useFilteredCoursePauseRequests({
      requestType,
      coursePauseStatus: COURSE_PAUSE_REQUEST_STATUSES.accepted,
    });

  if (isLoading) {
    return <Loader />;
  } else if (error) {
    return (
      <ErrorLayout
        title="Failed to load course pause requests"
        message={error.data?.message || 'Something went wrong! Try again later'}
        actionFn={refetch}
      />
    );
  } else if (data?.data?.length > 0) {
    const coursePauseRequests = data.data;

    return (
      <>
        <GlobalLoader isVisible={isFetching} />
        <Table className={styles.root}>
          <ToBeResumedTableHeader />
          <TableBody className={styles.rows}>
            {coursePauseRequests?.map((request) => (
              <ToBeResumedTableRow
                request={request}
                key={request.id}
              />
            ))}
          </TableBody>
        </Table>
        <ElementSpacePlaceholder elementId="to-be-resume-request-pagination" />
        <div
          id="to-be-resume-request-pagination"
          className={styles.pagination}
        >
          <CoursePauseRequestPagination
            pageCount={data.meta.total}
            currentPage={currentPage}
          />
        </div>
      </>
    );
  } else {
    return (
      <ErrorLayout
        title="No requests found!"
        message="No requests to be resumed in upcoming days exists at the moment."
      />
    );
  }
}

export default ToBeResumedTable;
